var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowdownsvg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4992 0.398644C16.8882 -0.212356 16.5082 -0.0683557 15.9662 0.474644L8.98022 7.46064L1.94122 0.395644C1.44522 -0.101356 1.05822 -0.153356 0.519221 0.385644C-0.0207789 0.925644 0.00222111 1.28464 0.513221 1.79564L7.56622 8.87564L8.04622 9.35564C8.43922 9.74864 8.66222 9.99964 8.98022 9.99964C9.27522 9.99964 9.50022 9.78464 9.84222 9.44064L10.3962 8.87764L17.4162 1.85764C17.9602 1.31464 18.0682 0.968644 17.4992 0.398644Z",
    fill: "#1D6460"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowdownsvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowdownsvg.f1a9c5aa92a362ceb07a11a5a319626a.svg";